import React from 'react';
import { Time } from './Time';

interface DaysAgoProps {
  /**
   * The date string to calculate days ago from. Can be any valid date string parseable by Date.parse().
   */
  date: string;

  /**
   * Optional CSS class name to apply to the time element.
   */
  className?: string;
}

/**
 * DaysAgo component for displaying how many days ago a date was.
 * Renders the days ago text inside a Time component.
 * @param props The component props.
 * @returns JSX.Element
 */
export const DaysAgo: React.FC<DaysAgoProps> = ({ date, className }) => {
  const timestamp = Date.parse(date);
  const dateObject = new Date(timestamp);
  const today = new Date();

  // Calculate the number of days between the two dates
  const timeDiff = today.getTime() - dateObject.getTime();
  const daysAgo = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

  let text: string;
  if (daysAgo === 0) {
    text = 'today';
  } else if (daysAgo === 1) {
    text = '1 day ago';
  } else {
    text = `${daysAgo} days ago`;
  }

  return (
    <Time date={date} className={className}>
      {text}
    </Time>
  );
};
